import React, { Component } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Form, Grid, GridColumn, Header, Icon, Segment, Tab } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';

class FaqEdit extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            edit: false,
            question: JSON.parse(localStorage.getItem('faqItem')).question,
            answer: JSON.parse(localStorage.getItem('faqItem')).answer,
            role: JSON.parse(localStorage.getItem('faqItem')).userTypes ? JSON.parse(localStorage.getItem('faqItem')).userTypes.map(e => e.id) : [],
            optLock: JSON.parse(localStorage.getItem('faqItem')).optLock,
            id: JSON.parse(localStorage.getItem('faqItem')).id,
            // key: JSON.parse(localStorage.getItem('faqItem')).key,
            roleOptions: [],
        };

        this.updateFaq = this.updateFaq.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        axios.get('/user-types')
            .then(res => {
                const roleOptions = res.data.sort((a, b) => a.name.localeCompare(b.name)).map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    roleOptions
                });
            }).catch(err => {

            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    updateFaq(role, question, answer) {
        if (!question || !answer) {
            if (!question) { this.setState({ questionErr: true }); } else { this.setState({ questionErr: false }); }
            if (!answer) { this.setState({ answerErr: true }); } else { this.setState({ answerErr: false }); }
            // if (role.length === 0) { this.setState({ roleErr: true }); } else { this.setState({ roleErr: false }); }

            toast('Morate unijeti obavezna polja');
        } else {
            let userTypes = this.state.role.map(e => ({ id: e }));
            let newFaq = {
                id: this.state.id,
                optLock: this.state.optLock,
                userTypes,
                question: this.state.question,
                answer: this.state.answer,


            };


            axios.put('/faq/update', { ...newFaq })
                .then(res => {
                    this.props.closeEditMode();
                    this.props.fetchData();
                    toast('Uspješno ste izmijenili pitanje!');
                    // this.resetValues();
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                });
        }
    }
    render() {
        return (
            <Segment>

                <Segment clearing secondary>
                    <Form>
                        <Grid columns={2} >
                            <GridColumn>
                                <Form.Field required>
                                    <label>Uloga</label>
                                    <Form.Dropdown
                                        multiple
                                        placeholder="Odaberite ulogu"
                                        value={this.state.role}
                                        onChange={this.handleInputChange}
                                        name="role"
                                        options={this.state.roleOptions}
                                        search
                                        flu
                                        selection
                                        error={this.state.roleErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Pitanje</label>
                                    <Form.TextArea
                                        placeholder="Unesite pitanje"
                                        rows={3}
                                        onChange={this.handleInputChange}
                                        value={this.state.question}
                                        name="question"
                                        error={this.state.questionErr}
                                    />
                                </Form.Field>
                            </GridColumn>
                            <GridColumn>
                                <Form.Field width="16" type="textarea" required>
                                    <label>Odgovor</label>
                                    <Form.TextArea
                                        placeholder="Unesite odgovor"
                                        rows={7}
                                        onChange={this.handleInputChange}
                                        value={this.state.answer}
                                        name="answer"
                                        error={this.state.answerErr}
                                    />
                                </Form.Field>
                            </GridColumn>
                        </Grid>
                        <br />
                        <Button color="blue" basic="true" floated="right" onClick={this.props.closeEditMode}>Odustani</Button>
                        <Button

                            color="blue"
                            floated="right"
                            disabled={localStorage.getItem('finalized')}
                            onClick={() => this.updateFaq(this.state.question, this.state.answer, this.state.role)
                            }
                        >
                            Sačuvaj izmjene
                        </Button>
                    </Form>
                </Segment>


            </Segment>
        );
    }
}

export default FaqEdit;



// WEBPACK FOOTER //
// ./src/views/Admin/FAQ/FAQEdit.js